import { Button } from "@mui/material"
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
    link: {
        borderRadius: "0px",
        fontSize: "1rem",
        fontWeight: 500,
        textAlign: "center",
        textDecoration: "none",
        height: "inherit",
        padding: "1.2rem",
    },
}));

interface INavigationMenuItemProps {
    name: string,
    enabled?: boolean,
    onClick?: () => void,
    disableRipple?: boolean,
    sub?: boolean,
    selected?: boolean
    slightBorder?: boolean
}

const NavigationMenuItem: React.FC<INavigationMenuItemProps> = (props) => {
    const classes = useStyles()

    const getBorder = () => {
        if (props.selected) {
            return "solid"
        }
        if (props.slightBorder) {
            return "solid 1px #dce1e6"
        }
        return undefined
    } 

    return (
        <Button
            className={classes.link}
            style={{
                paddingLeft: props.sub? "1.9rem" : "1.2rem",
                backgroundColor: props.sub? "#f7f7f7" : undefined,
                borderBottom: getBorder(),
                width: "100%"
            }}
            onClick={props.onClick}
            disableRipple={props.disableRipple}
            color="primary"
        >
            {props.name}
        </Button>
    )
}

export default NavigationMenuItem
